import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { Icon } from '@photosi/rn-components/icon/Icon';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { styles } from './PickerGooglePhotoErrors.styles';

export const PickerGooglePhotoErrors = observer(() => {
  const {
    i18n,
    googleAccount: { isUserLogged, hasGivenAccessToPhoto },
  } = useStore();

  return isUserLogged && !hasGivenAccessToPhoto ? (
    <View style={styles.errorWrapper}>
      <View style={styles.iconError}>
        <Icon name={ICON_NAMES.Alert} color={styles.textError.color} />
      </View>
      <TextLato style={styles.textError}>{i18n.t('modal-picker-google-photo:errors:no-access')}</TextLato>
    </View>
  ) : (
    <></>
  );
});
